import { P2GGrid, SvgConfirmSmall, P2GProgress, P2GText } from '@parcel2go/core-ui';
import ProviderName from '../../../../lib/helpers/ProviderName';
import { ProviderGroupItemSummary, ProviderGroupState } from '../../../../lib/helpers/SmartSendBulkActionApplier';

import { ServiceImage } from '../../item/ItemService';
import { ItemHasVat } from './HasVat';
import { toDisplayCurrency } from '~/components/currency/toDisplayCurrency';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { useTaxName } from '@parcel2go/npm-p2g-app';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  item: ProviderGroupItemSummary;
  state: ProviderGroupState;
}

export default function ServiceSummary(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const groupHasVat = ItemHasVat(props.item);
  const taxName = useTaxName();

  return (
    <P2GGrid container wrap="nowrap" alignItems="center" gap={1}>
      <P2GGrid item flexShrink={1}>
        <ServiceImage width={50} service={props.item.Service} />
      </P2GGrid>
      <P2GGrid item flexGrow={1}>
        <P2GText variant="body2">
          {props.item.Count} x {props.item.Service.Name || ProviderName(props.item.Service.Provider)}
        </P2GText>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        {props.state === 'IDLE' && props.item.TotalPriceExVat > 0 && (
          <P2GText variant="body2">
            {toDisplayCurrency(props.item.CurrencyCode, props.item.TotalPriceExVat)}
            {groupHasVat && (
              <>
                &nbsp;
                <P2GText variant="body2" small>
                  {t(`EXCLUDING_TAX_SERVICE_SUMMARY`, { defaultValue: `exc {{taxName}}`, taxName: taxName })}
                </P2GText>
              </>
            )}
          </P2GText>
        )}
        {['BOOKED', 'STAGED'].includes(props.state) && (
          <CdnIconProxy size="sm" palette="success" src="/theme/icons/ConfirmSmall.svg">
            <SvgConfirmSmall />
          </CdnIconProxy>
        )}
        {props.state === 'BOOKING' && (
          <CdnIconProxy size="sm" palette="primary" src="/theme/icons/Progress.svg">
            <P2GProgress size="small" />
          </CdnIconProxy>
        )}
      </P2GGrid>
    </P2GGrid>
  );
}
